<template>
    <div id="Mosaico">
      <div v-if="isLoading" class="loader">
        <div class="preloader-wrapper big active">
            <div class="spinner-layer spinner-white-only">
              <div class="circle-clipper left">
                <div class="circle"></div>
              </div><div class="gap-patch">
                <div class="circle"></div>
              </div><div class="circle-clipper right">
                <div class="circle"></div>
              </div>
            </div>
          </div>
      </div>
      <div v-if="!isLoading">
        <div v-masonry transition-duration="0.3s" item-selector=".item" class="masonry-container" 
            v-viewer="{
                inline: false, 
                navbar: true,
                toolbar: false,
                title: false,
            }"
        >   
          <div v-masonry-tile class="item">
            <div class="itemVideo r16x9">
              <iframe class="responsive-iframe" src="https://www.youtube.com/embed/vpm47cGoh1A" title="Roberto Pagliaccia - When We Were Kids" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
          <div v-masonry-tile class="item" v-for="img in imgs" :key="img.id">
            <img :src="img.url" :alt="'home photo '+img.id" />
          </div>
        </div>
      </div>
    </div>
</template>

<script async defer src="https://cdnjs.cloudflare.com/ajax/libs/masonry/4.0.0/masonry.pkgd.min.js"></script>
<script>
import Vue from 'vue'
import {VueMasonryPlugin} from 'vue-masonry';
Vue.use(VueMasonryPlugin);

import 'viewerjs/dist/viewer.css'
import Viewer from 'v-viewer'
Vue.use(Viewer);

export default{
    name: 'Mosaico',
    data () {
        return {
            isLoading: false,
            imgs: [],
            }
    },
    mounted(){
        this.isLoading = true;
        for(let i=1; i<=10 ; i++){
          var newPhoto = {
            id: i,
            url: "https://www.matteortili.com/imgs/home2/_("+i+").jpg"
          }
          this.imgs.push(newPhoto);
        }
        this.isLoading = false;
    }
}   

</script>

<style scoped>
.masonry-container {
    width: 100%;
    margin: 0 auto;
}

  .grid-sizer,
  .item {
    width: 33.3333%;
  }
  @media (max-width: 892px){
    .grid-sizer,
    .item {
      width: 50%;
    }
  }

  @media (max-width: 450px){
    .grid-sizer,
    .item {
      width: 100%;
    }
  }

  .item {
    float: left;
  }

  .item img {
    display: block;
    width: 100%;
  }

   .item > img:hover {
    filter:grayscale(70%);
    cursor: pointer;
    transition: 300ms;
  }


  a{
      color: #222;
      text-decoration: none !important;
  }

  .cell-wrapper{
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      cursor: pointer;
      background-color: rgba(250, 250, 250, 0.424);
      opacity: 0;
      color: rgb(15, 15, 15);
      display: flex;
      align-items: center;
      justify-content: center;
      transition: opacity .2s ease-out;
  }

  .cell-wrapper:hover{
      opacity: 1;
  }

  .loader{
    margin-top: 5vh;
    margin-bottom: 5vh;
    text-align: center;
  }



  /* VIDEO ITEM */
  .itemVideo{
    position: relative;
    overflow: hidden;
    width: 100%; 
  }
  .responsive-iframe {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
  }
  .r16x9{
    padding-top: 56.25%;
  }
  .r4x3{
    padding-top: 66.66%;
  }
  .r8x5{
    padding-top: 62.5%;
  }
  .r1x1{
    padding-top: 100%;
  }

</style>